import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const displayArticles = articles.filter(a => a.slug !== 'acbuy-spreadsheet-guide');

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase rounded-full bg-primary-100 text-primary-700 mb-4">
            SEO Articles & Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            ACBuy Spreadsheet In-Depth Guides
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base leading-relaxed">
            Explore our collection of detailed buying guides covering every ACBuy spreadsheet category.
            Each article is packed with price comparisons, seller tips, and expert shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] bg-background-100 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-2 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400 flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="text-xs font-medium text-primary-600 flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                    Read Article
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200"
          >
            View the Complete Shopping Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}